module.exports = __webpack_public_path__ + "img/dingding.32c4fdeb.svg";